'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Home, ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import Header from '@/components/Header'; // <-- 1. Добавлен импорт хедера

export default function NotFound() {
  const router = useRouter();

  return (
    <>
      {/* 2. Выводим хедер */}
      <Header /> 

      {/* 3. Добавлен pt-24 (padding-top), чтобы сдвинуть контент страницы вниз */}
      <div className="min-h-[85vh] pt-24 flex flex-col items-center justify-center relative overflow-hidden px-4">
        
        {/* Декоративный фон страницы */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-indigo-600/5 blur-[120px] rounded-full pointer-events-none z-0" />

        <div className="relative z-10 flex flex-col items-center text-center w-full max-w-2xl mx-auto">
          
          {/* ОГРОМНЫЙ ТЕКСТ 404 НА ЗАДНЕМ ПЛАНЕ */}
          {/* Чуть уменьшен сдвиг вверх (было -translate-y-8, стало -translate-y-2) */}
          <h1 className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-2 text-[120px] md:text-[200px] font-black text-white/[0.03] leading-none tracking-tighter select-none pointer-events-none z-0">
            404
          </h1>

          {/* КОНТЕЙНЕР С ПЕРСОНАЖЕМ (АНОМАЛИЯ) */}
          {/* Увеличен mt-8 до mt-20, чтобы картинка была ниже */}
          <div className="relative mb-6 mt-20 flex justify-center items-center w-full h-[280px] md:h-[320px]">
            
            {/* 1. Глубокое космическое свечение */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[180px] h-[180px] md:w-[220px] md:h-[220px] bg-gradient-to-tr from-indigo-500/40 to-cyan-400/40 blur-[50px] rounded-full z-0 animate-pulse" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100px] h-[100px] bg-white/20 blur-[30px] rounded-full z-0" />

            {/* 2. Вращающиеся технологичные/магические кольца портала */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[220px] md:w-[260px] md:h-[260px] rounded-full border-[2px] border-indigo-500/20 border-dashed animate-[spin_10s_linear_infinite] z-0" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[240px] h-[240px] md:w-[280px] md:h-[280px] rounded-full border border-cyan-400/10 animate-[spin_15s_linear_infinite_reverse] z-0" />

            {/* 3. Плавающие частицы (магия/баги) */}
            <div className="absolute top-[10%] left-[25%] w-2 h-2 bg-cyan-400 rounded-full blur-[2px] animate-[bounce_3s_infinite] z-0" />
            <div className="absolute bottom-[20%] right-[25%] w-3 h-3 bg-indigo-500 rounded-full blur-[2px] animate-[bounce_4s_infinite_reverse] z-0" />
            <div className="absolute top-[30%] right-[20%] w-1.5 h-1.5 bg-white/60 rounded-full blur-[1px] animate-pulse z-0" />

            {/* Сам персонаж с парением и собственным цветным свечением */}
            <div className="relative z-10 animate-[bounce_4s_ease-in-out_infinite]">
              <Image 
                src="/404-image.png" 
                alt="404 - Страница не найдена" 
                width={300} 
                height={300}
                className="object-contain drop-shadow-[0_10px_30px_rgba(34,211,238,0.25)]"
                priority
              />
            </div>

            <div className="absolute bottom-4 md:bottom-2 left-1/2 -translate-x-1/2 w-[140px] h-[15px] bg-indigo-500/40 blur-[15px] rounded-[100%] z-0 animate-[pulse_4s_ease-in-out_infinite]" />
            <div className="absolute bottom-5 md:bottom-3 left-1/2 -translate-x-1/2 w-[80px] h-[4px] bg-cyan-400/60 blur-[3px] rounded-[100%] z-0" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 relative z-10 drop-shadow-md">
            Упс! Вы забрели не туда
          </h2>
          
          <p className="text-zinc-400 max-w-md mx-auto mb-10 text-sm md:text-base leading-relaxed relative z-10">
            Похоже, эта локация не существует. Возможно, вы ошиблись координатами или блок был сломан.
          </p>

          {/* Кнопки */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto relative z-10">
            
            <Link 
              href="/" 
              className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 bg-white text-black font-bold rounded-xl hover:bg-zinc-200 transition-all active:scale-95 shadow-[0_0_20px_rgba(255,255,255,0.15)]"
            >
              <Home size={18} />
              На главную
            </Link>

            <button 
              onClick={() => router.back()}
              className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 bg-[#151515] border border-white/10 text-white font-medium rounded-xl hover:bg-white/5 transition-all active:scale-95 cursor-pointer outline-none"
            >
              <ArrowLeft size={18} />
              Вернуться назад
            </button>
            
          </div>
        </div>
      </div>
    </>
  );
}